enum TaxiContractMaintenancePolicy {
  BASIC = "BASIC",
  AUCTION = "AUCTION",
}

export default TaxiContractMaintenancePolicy;
